import paymentSlice from './slice/payment/slice';
import quoteSlice from './slice/quote/slice';
import marketPriceSlice from './slice/marketPrice/slice';

import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    payment: paymentSlice,
    quote: quoteSlice,
    marketPrice: marketPriceSlice,
  },
});
